{
  "actions": "Działania"
}
